import toast from 'react-hot-toast';
import { useDynamicEntityStoreContext, useDynamicEntityCMSDataContext } from '../../contexts';

const copyToClipboard = (text) => {
  try {
    navigator.clipboard.writeText(text);
    toast('Text copied to clipboard!');
  } catch (err) {
    toast.error('Failed to copy text');
    console.error('Failed to copy text: ', err);
  }
};

export default function LocaleOption({ hreflangGroupId, locale, assigned, handleAssignment, handleUnassignment }) {
  const { endpoints } = useDynamicEntityCMSDataContext();
  const { editDynamicPageUrl } = endpoints;

  const assignedHreflangGroupId = useDynamicEntityStoreContext((state) => state.data.assigned_hreflang_group.hreflang_group_id);
  const assignedHreflangGroupLocale = useDynamicEntityStoreContext((state) => state.data.assigned_hreflang_group.locale);

  const isAssigned = assigned !== null && assigned !== undefined;
  const isThisPageAssigned = assignedHreflangGroupId === hreflangGroupId && assignedHreflangGroupLocale === locale;

  const onClick = () => {
    if (isAssigned) {
      handleUnassignment();
    } else {
      handleAssignment();
    }
  };

  const assignedUrl = `${editDynamicPageUrl.replace(':id', assigned?.assignable_id)}`;

  return (
    <div className="d-flex flex-column gap-2 border rounded p-2">
      <div className="input-group input-group-sm">
        <div className="input-group-text w-50 d-flex gap-2" id="inputGroup-sizing-sm">
          <span>{locale}</span>
          {isThisPageAssigned && <span className="badge bg-primary">This page</span>}
        </div>
        <button className={`btn btn-outline-${!isAssigned ? 'secondary' : 'danger'} w-50`} type="button" onClick={onClick}>
          {isAssigned ? 'Unassign' : 'Assign'}
        </button>
      </div>
      {isAssigned ? (
        <div className="d-flex flex-column gap-3">
          <div className="d-flex justify-content-center align-items-center">
            <label>
              Assigned to <span className="badge bg-secondary">{assigned.assignable_type === 'DynamicPage' ? 'Builder Page' : 'Template'}</span>{' '}
            </label>
          </div>
          <div className="d-flex flex-column gap-3 w-100">
            <div className="d-flex gap-2 justify-content-center align-items-center">
              <div className="input-group input-group-sm">
                <span className="input-group-text">Title</span>
                <input type="text" className="form-control" value={assigned.assignable_title} readOnly />
              </div>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => copyToClipboard(assigned.assignable_title)} title="Copy title">
                <i className="fe fe-clipboard" />
              </button>
            </div>
            <div className="d-flex gap-2 justify-content-center align-items-center">
              <div className="input-group input-group-sm">
                <span className="input-group-text">URL Slug</span>
                <input type="text" className="form-control" value={assigned.assignable_url_slug} readOnly />
              </div>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => copyToClipboard(assigned.assignable_url_slug)} title="Copy URL slug">
                <i className="fe fe-clipboard" />
              </button>
            </div>
            {!isThisPageAssigned && isAssigned && (
              <a className="btn btn-link" href={assignedUrl}>
                Go to this page <i className="fe fe-arrow-right" />
              </a>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100">
          <span className="text-muted">This page is not assigned.</span>
        </div>
      )}
    </div>
  );
}
